import { Outlet } from 'react-router-dom';
import LandingHeader from '../layout/LandingHeader';
import LandingFooter from '../layout/LandingFooter';

export default function LandingLayout() {
  return (
    <div className="min-h-screen bg-white dark:bg-tutara-dark-mode-bg flex flex-col">
      <LandingHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <LandingFooter />
    </div>
  );
}